import FileReferenceDefinition from '../FileReferenceDefinition';

const definition: FileReferenceDefinition = {
  name: 'BrowserProcessFailedEventArgs',
  type: 'class',
  description: 'Event args for [StandaloneWebView.BrowserProcessFailed](/webview/StandaloneWebView#BrowserProcessFailed).',
  inheritsFrom: 'System.EventArgs',
  members: [
    {
      name: 'ErrorMessage',
      returns: 'string',
      type: 'property',
      description: 'An error message describing the failure that occurred.'
    }
  ]
};
export default definition;
